import _objectWithoutPropertiesLoose from "@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";
import _someInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/some";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _pt from "prop-types";
import React from 'react';
import vegaEmbed from 'vega-embed';
import shallowEqual from './utils/shallowEqual';
import getUniqueFieldNames from './utils/getUniqueFieldNames';
import { NOOP } from './constants';
import addSignalListenersToView from './utils/addSignalListenersToView';
import computeSpecChanges from './utils/computeSpecChanges';
import removeSignalListenersFromView from './utils/removeSignalListenersFromView';

var VegaEmbed = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(VegaEmbed, _React$PureComponent);

  function VegaEmbed() {
    var _context;

    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;

    _defineProperty(_assertThisInitialized(_this), "containerRef", React.createRef());

    _defineProperty(_assertThisInitialized(_this), "viewPromise", void 0);

    _defineProperty(_assertThisInitialized(_this), "handleError", function (error) {
      var _this$props$onError = _this.props.onError,
          onError = _this$props$onError === void 0 ? NOOP : _this$props$onError;
      onError(error); // eslint-disable-next-line no-console

      console.warn(error);
      return undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "modifyView", function (action) {
      if (_this.viewPromise) {
        _this.viewPromise.then(function (view) {
          if (view) {
            action(view);
          }

          return true;
        }).catch(_this.handleError);
      }
    });

    return _this;
  }

  var _proto = VegaEmbed.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.createView();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _context2,
        _this2 = this;

    var fieldSet = getUniqueFieldNames([this.props, prevProps]);
    fieldSet.delete('className');
    fieldSet.delete('signalListeners');
    fieldSet.delete('spec');
    fieldSet.delete('style'); // Only create a new view if necessary

    if (_someInstanceProperty(_context2 = _Array$from(fieldSet)).call(_context2, function (f) {
      return _this2.props[f] !== prevProps[f];
    })) {
      this.clearView();
      this.createView();
    } else {
      var specChanges = computeSpecChanges(this.props.spec, prevProps.spec);
      var newSignalListeners = this.props.signalListeners;
      var oldSignalListeners = prevProps.signalListeners;

      if (specChanges) {
        if (specChanges.isExpensive) {
          this.clearView();
          this.createView();
        } else {
          var areSignalListenersChanged = !shallowEqual(newSignalListeners, oldSignalListeners);
          this.modifyView(function (view) {
            if (specChanges.width !== false) {
              view.width(specChanges.width);
            }

            if (specChanges.height !== false) {
              view.height(specChanges.height);
            }

            if (areSignalListenersChanged) {
              if (oldSignalListeners) {
                removeSignalListenersFromView(view, oldSignalListeners);
              }

              if (newSignalListeners) {
                addSignalListenersToView(view, newSignalListeners);
              }
            }

            view.run();
          });
        }
      } else {
        var _areSignalListenersChanged = !shallowEqual(newSignalListeners, oldSignalListeners);

        this.modifyView(function (view) {
          if (_areSignalListenersChanged) {
            if (oldSignalListeners) {
              removeSignalListenersFromView(view, oldSignalListeners);
            }

            if (newSignalListeners) {
              addSignalListenersToView(view, newSignalListeners);
            }
          }

          view.run();
        });
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.clearView();
  };

  _proto.createView = function createView() {
    var _this$props = this.props,
        spec = _this$props.spec,
        onNewView = _this$props.onNewView,
        _this$props$signalLis = _this$props.signalListeners,
        signalListeners = _this$props$signalLis === void 0 ? {} : _this$props$signalLis,
        options = _objectWithoutPropertiesLoose(_this$props, ["spec", "onNewView", "signalListeners"]);

    if (this.containerRef.current) {
      this.viewPromise = vegaEmbed(this.containerRef.current, spec, options).then(function (_ref) {
        var view = _ref.view;

        if (addSignalListenersToView(view, signalListeners)) {
          view.run();
        }

        return view;
      }).catch(this.handleError);

      if (onNewView) {
        this.modifyView(onNewView);
      }
    }
  };

  _proto.clearView = function clearView() {
    this.modifyView(function (view) {
      view.finalize();
    });
    this.viewPromise = undefined;
    return this;
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        className = _this$props2.className,
        style = _this$props2.style;
    return (// Create the container Vega draws inside
      React.createElement("div", {
        ref: this.containerRef,
        className: className,
        style: style
      })
    );
  };

  return VegaEmbed;
}(React.PureComponent);

_defineProperty(VegaEmbed, "propTypes", {
  className: _pt.string,
  onError: _pt.func
});

export { VegaEmbed as default };